import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import ProfileImage from '@buyside/components/presentation/ProfileImage/profileImage';

import { getIcon, getLinkUrl, getTag } from '@buyside/util/notificationHelper';

import { UserNotificationFragment, useViewNotificationMutation } from '@interfaces/graphql-typings';

import styles from './navigationNotificationsStyles.scss';

const Notification: React.FC<{
  currentUserId: string;
  notification: UserNotificationFragment;
}> = ({ currentUserId, notification }) => {
  const {
    associatedUser,
    createdAt,
    customLink,
    description,
    id: notificationId,
    linkId,
    notificationClass,
    viewed
  } = notification;

  const [handleViewNotification] = useViewNotificationMutation({
    variables: { notificationId }
  });

  const Icon = getIcon(notificationClass, linkId);

  const viewNotification = async (): Promise<void> => {
    if (!viewed) await handleViewNotification();

    const notificationHref = getLinkUrl(notificationClass, linkId, currentUserId, customLink);

    if (notificationHref) window.location.href = notificationHref;
  };

  return (
    <div
      data-testid="notification-link"
      className={classNames(styles.notification, { [styles.unread]: !viewed })}
      data-heap={getTag(notificationClass)}
      onClick={viewNotification}
    >
      <div>
        {(Icon && (
          <Icon
            className={classNames(styles.notificationIcon, {
              [styles.contestWinner]: notificationClass === 'contest_winner',
              [styles.contestFinalist]: notificationClass === 'contest_finalist',
              [styles.placedInContest]: notificationClass === 'contest_placed'
            })}
          />
        )) ||
          (associatedUser && (
            <ProfileImage
              size="small"
              noMargin
              source={
                associatedUser.isAllocator
                  ? associatedUser.allocatorProfileLogoUrl
                  : associatedUser.profileImageUrl
              }
            />
          ))}
      </div>
      <div>
        <div>{description}</div>
        {createdAt && <div>{moment(new Date(createdAt)).format('MM/DD/YYYY, h:mm a')}</div>}
      </div>
    </div>
  );
};

export default Notification;
